import { observer } from "mobx-react-lite";
import { CleanUpActions } from "@/components/note/floating-actions/clean-up-actions";
import { MemCommonEditorStore } from "@/components/note/store/mem-common-editor-store";
import { useEffect, useRef, useState } from "react";
import {
  MDSButton,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIcon,
  MDSIconKind,
  MDSPopover,
  MDSTooltip,
  MDSTooltipPlacement,
} from "@/mds";
import styled from "@emotion/styled";
import { getShortcutTooltipConfig } from "@/modules/keyboard-shortcuts/tooltip";

interface CleanUpIndicatorProps {
  editorStore: MemCommonEditorStore;
  toggleRequestCount?: number;
}

export const CleanUpIndicator = observer(
  ({ editorStore, toggleRequestCount = 0 }: CleanUpIndicatorProps) => {
    const [isOpen, setIsOpen] = useState(true);
    const ref = useRef<HTMLButtonElement>(null);

    useEffect(() => {
      if (!toggleRequestCount) {
        return;
      }

      setIsOpen(isOpen => !isOpen);
    }, [toggleRequestCount]);

    return (
      <>
        <MDSTooltip
          config={getShortcutTooltipConfig({
            action: "toggle_voice_cleanup_panel",
            label: "Toggle Clean up panel",
            placement: MDSTooltipPlacement.Top,
          })}
        >
          <StyledButton
            ref={ref}
            variant={MDSButtonVariant.EmphasisLight}
            onClick={() => setIsOpen(isOpen => !isOpen)}
          >
            <MDSIcon kind={MDSIconKind.Cleanup} slot={MDSButtonSlotName.LeftIcon} />
            <span>Clean up</span>
            <MDSIcon
              kind={isOpen ? MDSIconKind.AngleDown : MDSIconKind.AngleUp}
              slot={MDSButtonSlotName.RightIcon}
            />
          </StyledButton>
        </MDSTooltip>
        {editorStore && (
          <MDSPopover
            styling={false}
            triggerRef={ref}
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            isNonModal={true}
          >
            <CleanUpActions editorStore={editorStore} />
          </MDSPopover>
        )}
      </>
    );
  }
);

const StyledButton = styled(MDSButton)`
  height: 32px;
`;
